/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import { Form, Input, InputRef, Select, Table, Tag } from "antd"
import classNames from "classnames"
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
import { TabName } from "./TableProject"
import { FaDatabase } from "react-icons/fa"
import { FiDatabase } from "react-icons/fi"
import { useEditApi } from "../../modules/api/ViewApiHooks"
import { getApiDetail } from "../../modules/api/api-rpc"
import axios from "axios"
import { useRunQueryApiV3 } from "../../modules/dataset/tabs/GraphqlHooksV3"
import GraphqlV3 from "../../modules/dataset/tabs/GraphqlV3"

import testMD from './test.md'
import { useParams } from "react-router"
import { getTableDetailById, getTablePreview, updateTableColumnsMetadata } from "../workspace/apis"
import { FormInstance, useForm } from "antd/es/form/Form"
import MarkdownBlock from "./MarkdownBlock"
import { ModelGetTableDetailResponse, PoTableMetadata } from "../../api/__gen__/data-contracts"
import ImagePicker from "../image-upload/ImagePicker"

interface EditableRowProps {
  index: number;
}

const EditableContext = createContext<FormInstance<any> | null>(null);
interface Item {
  [key: string]: string
}

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: keyof Item;
  record: Item;
  handleSave: (record: Item) => void;
}

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current!.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();

      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      // eslint-disable-next-line no-console
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={toggleEdit}>
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

// eslint-disable-next-line react/prop-types
export const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = useForm()
  return <Form form={form} component={false}>
    <EditableContext.Provider value={form}>
      <tr {...props} />
    </EditableContext.Provider>
  </Form>
}

export const TableDisplay = ({
  isEditMode = false,
  onUpdate
}: {
  isEditMode?: boolean
  onUpdate: (tableId: string, tableMetadata: {
    example: string
    summary: string
    desc: string
  }) => void
}) => {
  const [records, setRecords] = useState<any>([])
  const [{ graphqlState, runQuery }, loading] = useRunQueryApiV3();

  const params = useParams()

  const [tableDetail, setTableDetail] = useState<ModelGetTableDetailResponse>({})

  const [previewData, setPreviewData] = useState<any>([])
  const [columns, setColumns] = useState<any>([])

  useEffect(() => {
    const
      getAndSetData = async () => {
        if (!tableDetail || !tableDetail.table?.schema || !tableDetail.table.database || !tableDetail.table.name) return
        const res = await getTablePreview(tableDetail.table.schema, tableDetail.table.database, tableDetail.table.name)

        setPreviewData(res.rows)
        setColumns(res.metadata.columns.map(e => ({
          title: e.name,
          type: e.type,
          key: e.name,
          dataIndex: e.name,
          width: 200,
        })))
      }

    getAndSetData()
  }, [tableDetail?.table])



  const fetchAndSetTableDetail = async (tableId: string) => {
    const resp = await getTableDetailById(tableId);
    setTableDetail(resp)
  }
  useEffect(() => {
    if (!params.tableId) return
    fetchAndSetTableDetail(params.tableId)
  }, [params.tableId])


  useEffect(() => {
    const getAndSetData = async () => {
      const resp = await getApiDetail('sq_4ad669466b4c4c62bcb267387bda8e5f');

      const listOfColumns = resp?.data?.columns?.map((e: any) => e.name).join('\n')
      if (listOfColumns) {

        const queryStr = `query {
          records(limit: 10) {
            ${listOfColumns}
          }
        }`

        const res = await runQuery(queryStr, '', 'sq_4ad669466b4c4c62bcb267387bda8e5f')
        // await axios.post('https://qugate-dev-ztbl.api.zettablock.dev/qugate/v1/userapis/sq_4ad669466b4c4c62bcb267387bda8e5f/graphql', {
        //   query: queryStr
        // }, {
        //   withCredentials: true, headers: {
        //     Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDE1MDU0NDIsInVzZXJJZCI6ImQ3MjM4MzI2LTdkNjktNDczOS04ZTJkLWY4Yjk2MzQ5YmVmZCJ9.c7d-_qV9ua1e3YP-YVv_DU6EwDwkbuOfQEVErNh-ya8'
        //   }
        // })
        if (res?.data?.data?.records) {
          setRecords(res?.data?.data?.records)
        }
      }

    }

    getAndSetData()
  }, [])


  const [md, setMd] = useState<any>('')

  useEffect(() => {
    fetch(testMD).then((res) => res.text()).then((text) => {
      setMd(text)
    })
  })

  const tabs = Object.values(TabName)

  const [currentTab, setCurrentTab] = useState(TabName.COLUMNS)


  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };



  const [tableMetadata, setTableMetadata] = useState<any>({
    example: '',
    summary: '',
    desc: '',
  })

  useEffect(() => {
    setTableMetadata({
      example: tableDetail?.table?.example,
      summary: tableDetail?.table?.summary,
      desc: tableDetail?.table?.desc,
      chains: tableDetail?.table?.chains,
      labels: tableDetail?.table?.labels,
      image: tableDetail?.table?.image,
    })
  }, [tableDetail])

  const renderTabContent = useCallback(() => {
    switch (currentTab) {
      case TabName.OVERVIEW:
        return <div className="px-8 py-8">
          <MarkdownBlock
            isEditMode={isEditMode}
            value={
              isEditMode ? tableMetadata.desc : tableDetail?.table?.desc || '123'
            }
            onChange={(e) => {
              setTableMetadata({
                ...tableMetadata,
                desc: e
              })
            }}
          />
        </div>
      case TabName.COLUMNS:
        return <div className="px-8 py-8">
          <Table
            dataSource={tableDetail?.column || []}
            components={components}
            rowClassName={() => 'editable-row'}
            columns={[
              {
                title: 'Title',
                dataIndex: 'name',
                key: 'name',
                // onCell: (record) => {
                //   return {
                //     record,
                //     editable: true,
                //     dataIndex: 'name',
                //     title: 'Title',
                //     handleSave: async (row: any) => {
                //       await updateTableColumnsMetadata(
                //         tableDetail.table.id,
                //         row.desc,
                //         row.name
                //       )
                //       await fetchAndSetTableDetail(params?.tableId || '')
                //     }
                //   }
                // },
                render: (text: string) => {
                  return <div className="flex items-center">
                    <FiDatabase />
                    <div className="ml-2">{text}</div>
                  </div>

                }
              },
              {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
              },
              {
                title: 'Description',
                dataIndex: 'desc',
                key: 'desc',
                render: (text: string) => {
                  return text || '-'
                },
                onCell: (record) => {
                  return {
                    record,
                    editable: true,
                    dataIndex: 'desc',
                    title: 'Description',
                    handleSave: async (row: any) => {
                      await updateTableColumnsMetadata(
                        tableDetail?.table?.id || '',
                        row.desc,
                        row.name
                      )
                      await fetchAndSetTableDetail(params?.tableId || '')
                    }
                  }
                },
              },
              {
                title: 'Default',
                dataIndex: 'default',
                key: 'default',
              },

            ]}
          />
        </div>
      case TabName.PLAYGROUND:
        return <GraphqlV3 />
      case TabName.PREVIEW:
        return <div className="px-8 py-8">
          <Table
            style={{
              // maxWidth: 'calc(100%)',
              // overflow: 'auto'
            }}
            scroll={{
              x: 2000,
            }}
            dataSource={previewData}
            columns={columns}
          />
        </div>
      case TabName.EXAMPLE:
        return <div className="px-8 py-8">
          <MarkdownBlock
            isEditMode={isEditMode}
            value={
              isEditMode ? tableMetadata.example : tableDetail?.table?.example || ''
            }
            onChange={(e) => {
              setTableMetadata({
                ...tableMetadata,
                example: e
              })
            }}
          />
        </div>

      default:
        return null
    }
  }, [currentTab, tableDetail?.table, tableMetadata, isEditMode])


  return <div className="w-full max-w-[calc(100%-320px)] overflow-y-auto">
    {/* title and discription */}
    <div className="flex-1 min-w-fit  px-8 py-12">
      <div>
        <div className="text-2xl font-semibold mb-2 flex gap-3 items-center">
          <div>
            {
              tableDetail?.table?.name
            }
            <div className="flex gap-2">
              {tableMetadata?.chains?.map(e => {
                if (!e) return null
                return <div><Tag color="blue" className="cursor-pointer" key={e}>
                  {e}
                </Tag>
                </div>
              })}
              {tableMetadata?.labels?.map(e => {
                if (!e) return null
                return <div>
                  <Tag className="cursor-pointer" key={e}>
                    {e}
                  </Tag>
                </div>
              })}
            </div>
          </div>
          <div>
            <img className="object-contain" width={50} src={tableDetail.table?.image} />
          </div>
        </div>
        <div className="mt-2 w-1/2">
          {
            !isEditMode ? null : <Select
              mode="tags"
              style={{ width: '100%' }}
              placeholder="Chains"
              onChange={(e) => {
                setTableMetadata({
                  ...tableMetadata,
                  chains: e
                })
              }}
              value={tableMetadata.chains || []}
              options={tableMetadata.chains?.map(e => {
                return {
                  label: e,
                  value: e
                }
              })}
            />
          }

        </div>
        {
          isEditMode && <div className="mt-2 w-1/2">
            <ImagePicker
              onChange={(e) => {
                setTableMetadata({
                  ...tableMetadata,
                  image: e
                })
              }}
              value={tableMetadata?.image || ''} />
          </div>
        }
        <div className="mt-2 w-1/2">
          {
            !isEditMode ? null : <Select
              mode="tags"
              style={{ width: '100%' }}
              placeholder="Labels"
              value={tableMetadata.labels || []}
              onChange={(e) => {
                setTableMetadata({
                  ...tableMetadata,
                  labels: e
                })
              }}
              options={tableMetadata.labels?.map(e => {
                return {
                  label: e,
                  value: e
                }
              })}
            />
          }

        </div>
        <div className="" >
          {isEditMode ? <div className="flex gap-2 items-center group">
            <Input
              value={tableMetadata.summary}
              onChange={(e) => {
                setTableMetadata({
                  ...tableMetadata,
                  summary: e.target.value
                })
              }}
            />
            <div className="min-w-[80px] h-[36px]">
              <button className="btn btn-primary  group-hover:block" onClick={() => {
                if (params.tableId) {
                  onUpdate(params.tableId, tableMetadata)
                }

              }}>Update</button>
            </div>
          </div> :
            <span>
              {tableDetail?.table?.summary}
            </span>}

        </div>
      </div>
    </div>
    {/* Tabs */}
    <div className="w-full">
      <div role="tablist" className="tabs border-b-2 w-full gap-3">
        <div className="px-2"></div>
        {
          tabs.map((tab) => {
            return <a
              className={classNames('tab mb-[-2px] pb-2 text-lg', {
                'border-b-2 border-[#263dff] font-semibold text-[#000]': tab === currentTab,
              })}
              key={Math.random().toString()} role="tab" onClick={() => setCurrentTab(tab)}>
              {tab}
            </a>
          })
        }
      </div>
    </div>
    {/* tab content */}
    <div>{

      renderTabContent()
    }</div>
  </div>
}
